/* Scentasy — product gallery and mix-and-match body-butter bundles. */
(function () {
  'use strict';
  function initDailySaleCountdowns() {
    document.querySelectorAll('[data-bb-daily-sale], [data-sc-daily-sale]').forEach(function (sale) {
      if (sale.dataset.countdownInitialized) return;
      sale.dataset.countdownInitialized = 'true';
      function nextMidnight() {
        var next = new Date();
        next.setHours(24, 0, 0, 0);
        return next.getTime();
      }
      var endTime = nextMidnight();
      function write(value, unit) {
        var node = sale.querySelector('[data-bb-time="' + unit + '"]');
        if (node) node.textContent = String(value).padStart(2, '0');
      }
      function tick() {
        if (Date.now() >= endTime) endTime = nextMidnight();
        var seconds = Math.floor(Math.max(0, endTime - Date.now()) / 1000);
        write(Math.floor(seconds / 3600), 'hours');
        write(Math.floor(seconds % 3600 / 60), 'minutes');
        write(seconds % 60, 'seconds');
      }
      tick();
      window.setInterval(tick, 1000);
    });
  }
  function init() {
    var root = document.getElementById('bb-purchase');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    var form = root.querySelector('#bb-bundle-form');
    var offers = Array.from(root.querySelectorAll('.bb-offer'));
    var button = root.querySelector('#bb-add-to-cart');
    var error = root.querySelector('#bb-cart-error');
    var modal = document.getElementById('bb-scent-modal');
    var options = modal ? Array.from(modal.querySelectorAll('.bb-scent-modal-option')) : [];
    var scents = new Map(options.map(function (option) {
      return [Number(option.dataset.variantId), {
        id: Number(option.dataset.variantId),
        name: option.querySelector('.bb-scent-modal-name').textContent.trim(),
        inspiration: option.querySelector('.bb-scent-modal-copy small').textContent.trim(),
        image: option.querySelector('img') ? option.querySelector('img').getAttribute('src') : '',
        available: option.dataset.available === 'true'
      }];
    }));
    var current = offers.find(function (offer) { return offer.classList.contains('is-selected'); }) || offers[0];
    var activeTrigger = null;
    var savedOverflow = '';
    var unlocksReady = false;
    var money = function (value) { return '$' + Number(value).toFixed(2); };
    function initHalloweenSale() {
      var sale = root.querySelector('[data-bb-halloween-sale]');
      if (!sale) return;
      initDailySaleCountdowns();
    }
    function updateUnlocks(offer) {
      var panel = root.querySelector('[data-bb-unlocks]');
      if (!panel) return;
      var level = Number(offer.dataset.offer);
      var oneButter = panel.querySelector('[data-bb-perk="one-butter"]');
      var secondButter = panel.querySelector('[data-bb-perk="second-butter"]');
      function setUnlocked(item, unlocked) {
        var wasLocked = item.classList.contains('is-locked');
        item.classList.toggle('is-unlocked', unlocked);
        item.classList.toggle('is-locked', !unlocked);
        item.querySelector('.bb-unlock-state').textContent = unlocked ? 'Unlocked' : 'Locked';
        if (!unlocked) item.classList.remove('is-unlocking');
        if (unlocksReady && unlocked && wasLocked && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          item.classList.remove('is-unlocking');
          void item.offsetWidth;
          item.classList.add('is-unlocking');
          window.setTimeout(function () { item.classList.remove('is-unlocking'); }, 720);
        }
      }
      setUnlocked(oneButter, level >= 2);
      setUnlocked(secondButter, level >= 3);
      var note = panel.querySelector('[data-bb-unlocks-note]');
      if (level === 1) note.textContent = 'Free shipping unlocked. Select Buy 2 to unlock a free body butter.';
      else if (level === 2) note.textContent = 'Free shipping and 1 free body butter unlocked. Select Buy 3 to get 2 free body butters.';
      else note.textContent = 'All 2 free body butters unlocked. Added to your cart free.';
      unlocksReady = true;
    }
    function selectOffer(offer) {
      current = offer;
      offers.forEach(function (item) {
        var active = item === offer;
        item.classList.toggle('is-selected', active);
        item.querySelector('input[type="radio"]').checked = active;
        item.querySelector('.bb-scent-rows').hidden = !active;
      });
      root.querySelector('#bb-subtotal-price').textContent = money(offer.dataset.price);
      root.querySelector('#bb-subtotal-compare').textContent = money(offer.dataset.compare);
      root.querySelector('#bb-savings').textContent = money(Number(offer.dataset.compare) - Number(offer.dataset.price));
      updateUnlocks(offer);
    }
    function setScent(trigger, scent) {
      trigger.dataset.variantId = String(scent.id);
      trigger.querySelector('[data-bb-scent-name]').textContent = scent.name;
      trigger.querySelector('[data-bb-scent-inspiration]').textContent = scent.inspiration;
      var image = trigger.querySelector('[data-bb-scent-image]');
      if (image && scent.image) { image.src = scent.image; image.alt = scent.name; }
      var slot = trigger.closest('.bb-scent-row').querySelector('.bb-jar-label').textContent.replace(/\s+/g, ' ').trim();
      trigger.setAttribute('aria-label', 'Choose scent for ' + slot + ': ' + scent.name);
    }
    function closePicker() { if (modal && modal.open) modal.close(); }
    function openPicker(trigger) {
      if (!modal || !options.length) return;
      activeTrigger = trigger;
      options.forEach(function (option) {
        option.setAttribute('aria-checked', String(option.dataset.variantId === trigger.dataset.variantId));
      });
      savedOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      document.body.classList.add('bb-scent-picker-open');
      trigger.setAttribute('aria-expanded', 'true');
      modal.showModal();
      var selected = options.find(function (option) { return option.getAttribute('aria-checked') === 'true' && !option.disabled; }) || options.find(function (option) { return !option.disabled; });
      if (selected) { selected.focus({preventScroll: true}); selected.scrollIntoView({block: 'nearest'}); }
    }
    offers.forEach(function (offer) {
      offer.querySelector('input[type="radio"]').addEventListener('change', function () { selectOffer(offer); });
      offer.addEventListener('click', function (event) {
        if (!event.target.closest('[data-bb-scent-trigger]')) selectOffer(offer);
      });
    });
    root.querySelectorAll('[data-bb-scent-trigger]').forEach(function (trigger) {
      var scent = scents.get(Number(trigger.dataset.variantId));
      if (scent) setScent(trigger, scent);
      trigger.addEventListener('click', function () { openPicker(trigger); });
    });
    if (modal) {
      document.body.appendChild(modal);
      modal.querySelector('.bb-scent-modal-close').addEventListener('click', closePicker);
      modal.addEventListener('click', function (event) { if (event.target === modal) closePicker(); });
      modal.addEventListener('close', function () {
        document.body.style.overflow = savedOverflow;
        document.body.classList.remove('bb-scent-picker-open');
        if (activeTrigger && activeTrigger.isConnected) {
          activeTrigger.setAttribute('aria-expanded', 'false');
          activeTrigger.focus({preventScroll: true});
        }
      });
      options.forEach(function (option) {
        option.addEventListener('click', function () {
          var scent = scents.get(Number(option.dataset.variantId));
          if (!activeTrigger || !scent || !scent.available) return;
          setScent(activeTrigger, scent);
          closePicker();
        });
      });
      modal.querySelector('.bb-scent-modal-list').addEventListener('keydown', function (event) {
        if (['ArrowDown', 'ArrowUp', 'Home', 'End'].indexOf(event.key) === -1) return;
        event.preventDefault();
        var available = options.filter(function (option) { return !option.disabled; });
        if (!available.length) return;
        var index = available.indexOf(document.activeElement);
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = available.length - 1;
        else index = (index + (event.key === 'ArrowDown' ? 1 : -1) + available.length) % available.length;
        available[index].focus();
      });
    }
    selectOffer(current);
    initHalloweenSale();
    function selection() {
      var jars = Array.from(current.querySelectorAll('[data-bb-scent-trigger]')).map(function (trigger, index) {
        return {variantId: Number(trigger.dataset.variantId), scent: trigger.querySelector('[data-bb-scent-name]').textContent.trim(), free: index >= Number(current.dataset.paid)};
      });
      var grouped = new Map();
      jars.forEach(function (jar) { grouped.set(jar.variantId, (grouped.get(jar.variantId) || 0) + 1); });
      var items = Array.from(grouped, function (entry) { return {id: entry[0], quantity: entry[1]}; });
      return {variantId: jars.length ? jars[0].variantId : Number(root.dataset.variantId), quantity: Number(current.dataset.quantity), paidJars: Number(current.dataset.paid), offer: Number(current.dataset.offer), displayedPrice: Number(current.dataset.price), comparePrice: Number(current.dataset.compare), jars: jars, items: items};
    }
    window.WholeFormBodyButter = {getSelection: selection};
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (button.disabled) return;
      var chosen = selection();
      var valid = [1, 3, 5].indexOf(chosen.quantity) !== -1 && chosen.jars.length === chosen.quantity && chosen.items.every(function (item) {
        var scent = scents.get(item.id);
        return item.id > 0 && scent && scent.available && Number.isInteger(item.quantity) && item.quantity > 0;
      });
      if (!valid) {
        error.textContent = 'Please choose an available scent for each jar before adding your bundle.';
        error.hidden = false;
        return;
      }
      error.hidden = true;
      button.disabled = true;
      var label = button.querySelector('.bb-atc-label');
      label.textContent = 'Adding…';
      try {
        var response = await fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items: chosen.items})});
        var result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Could not add this offer to the cart.');
        label.textContent = 'Added to cart';
        if (typeof window.updateCartCount === 'function') window.updateCartCount();
        if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
        else window.location.assign('/cart');
      } catch (err) {
        error.textContent = err.message || 'Something went wrong. Please try again.';
        error.hidden = false;
      } finally {
        window.setTimeout(function () { label.textContent = 'Add to cart'; button.disabled = false; }, 800);
      }
    });
    var gallery = root.querySelector('#bb-gallery-slides');
    var slides = Array.from(gallery.querySelectorAll('.bb-gallery-slide'));
    var index = 0;
    function updateGallery(value) {
      index = Math.max(0, Math.min(value, slides.length - 1));
      root.querySelectorAll('[data-slide]').forEach(function (control) {
        var selected = Number(control.dataset.slide) === index;
        control.classList.toggle('is-active', selected);
        if (selected) control.setAttribute('aria-current', 'true');
        else control.removeAttribute('aria-current');
      });
    }
    function go(value) {
      updateGallery(value);
      gallery.scrollTo({left: gallery.clientWidth * index, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    root.querySelectorAll('[data-slide]').forEach(function (control) { control.addEventListener('click', function () { go(Number(control.dataset.slide)); }); });
    root.querySelector('.bb-gallery-prev').addEventListener('click', function () { go(index === 0 ? slides.length - 1 : index - 1); });
    root.querySelector('.bb-gallery-next').addEventListener('click', function () { go(index === slides.length - 1 ? 0 : index + 1); });
    gallery.addEventListener('scroll', function () { updateGallery(Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth))); }, {passive: true});
  }
  function boot() { initDailySaleCountdowns(); init(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
